(function (angular) {
    'use strict';

    angular.module('inboundRules')
        /**
         *
         */
        .controller('inboundRulesSettingsCtrl', ['$scope', '$stateParams', 'inboundRulesService', 'inboundRules', 'inboundRulesData', 'broadcastChannels', 'growlService',
            function ($scope, $stateParams, inboundRulesService, inboundRules, inboundRulesData, broadcastChannels, growlService) {

                $scope.inboundRules = inboundRules;

                var actionsConfiguration = [{
                    name: 'Autoreply',
                    id: 'replyMessage',
                    options: [{ name: 'messageParts', type: 'array' }]
                }, {
                    name: 'Update profile',
                    id: 'profileUpdate',
                    options: [{ name: 'profileUpdate', type: 'array' }]
                }, {
                    name: 'Forward to Chat',
                    id: 'startChat',
                    options: [{ name: 'chatTeamId', type: 'string' }]
                }];


                //settings that go into component
                $scope.settings = {
                    profileSchema: inboundRulesData.data.profileSchema,
                    usedChannels: prepareUsedChannels(),
                    availableChannels: inboundRulesData.data.availableChannels,
                    channels: broadcastChannels,
                    inboundOptions: {
                        fbPages: [inboundRulesData.data.fbPages],
                        teams: inboundRulesData.data.teams,
                        // prepend in a wildcard option (without modifying source)
                        inboundNumbers: [{name: "[ANY]", "number": "*"}].concat(inboundRulesData.data.inboundNumbers),
                        email: [inboundRulesData.data.email]
                    },
                    actionsConfiguration: actionsConfiguration,
                    defaultEmail: inboundRulesData.data.email ? inboundRulesData.data.email.defaultInboundAddress : '',
                    defaultMailboxName: inboundRulesData.data.email ? inboundRulesData.data.email.defaultMailboxName : ''
                };


                $scope.settings.channels.email = {
                    label: 'Email',
                    availableContent: ['text', 'image'],
                    id: 'email'
                };

                $scope.addNew = function () {
                    $scope.inboundRules.push({});
                };

                $scope.deleteRule = function (index) {
                    if ($scope.inboundRules[index].id) {
                        inboundRulesService.deleteInboundRule($stateParams.pickedApiSpaceId, $scope.inboundRules[index].id).then(function (data) {
                            growlService.success('Inbound rule successfully deleted');
                            $scope.inboundRules.splice(index, 1);
                        }).catch(function (error) {
                            growlService.danger("Inbound rule wasn't deleted due to: " + error.statusText);
                        });
                    }
                    else {
                        $scope.inboundRules.splice(index, 1);
                    }
                };

                $scope.save = function (index) {
                    if (!$scope.inboundRules[index].id) {
                        inboundRulesService.createInboundRule($stateParams.pickedApiSpaceId, getInboundRuleData($scope.inboundRules[index])).then(function (data) {
                            growlService.success('Inbound rule successfully created');
                            $scope.inboundRules[index].id = data.id;
                        }).catch(function (error) {
                            growlService.danger("Inbound rule wasn't created due to: " + error.statusText);
                        });
                    }
                    else {
                        inboundRulesService.updateInboundRule($stateParams.pickedApiSpaceId, getInboundRuleData($scope.inboundRules[index])).then(function (data) {
                            growlService.success('Inbound rule successfully updated');
                        }).catch(function (error) {
                            growlService.danger("Inbound rule wasn't updated due to: " + error.statusText);
                        });
                    }
                };

                function prepareUsedChannels() {
                    var usedChannels = {};
                    for (var i in inboundRulesData.data.teams) {
                        var channel = inboundRulesData.data.teams[i].channels;
                        for (var j in channel) {
                            if (!usedChannels[j]) {
                                usedChannels[j] = [];
                            }
                            var value = '';
                            switch (j) {
                                case 'email':
                                    value = channel[j].mailboxName;
                                    break;
                                case 'fbMessenger':
                                    value = channel[j].pageId;
                                    break;
                                case 'appMessaging':
                                    value = inboundRulesData.data.teams[i].teamId;
                                    break;
                                case 'sms':
                                    value = channel[j].inboundNumber;
                                    break;
                                default:
                                    break;
                            }
                            usedChannels[j].push(value);
                        }
                    }
                    return usedChannels;
                }

                function getInboundRuleData(data) {
                    var inboundRule = {};
                    if (data.id) {
                        inboundRule.id = data.id;
                    }
                    if (data.channel) {
                        inboundRule.channel = data.channel;
                    }
                    if (data.channel && data.inbound) {
                        inboundRule.inbound = data.inbound;
                    }
                    if (data.keyword) {
                        inboundRule.keyword = data.keyword;
                    }
                    if (data.action) {
                        inboundRule.action = data.action;
                    }
                    if (data.action && data.actionData) {
                        inboundRule.actionData = {};
                        actionsConfiguration.forEach(function (action) {
                                if (action.id == inboundRule.action) {
                                    action.options.forEach(function (option) {
                                        if (data.actionData[option.name] || typeof data.actionData[option.name] == 'boolean') {
                                            inboundRule.actionData[option.name] = data.actionData[option.name];
                                        }
                                    });

                                }
                            });
                    }
                    return inboundRule;
                }
            }]);
})(window.angular);